import "../App.css";
import { Link } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";

function OrderConfirmationPage({ setCartItems }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const navigate = useNavigate();

  // Access cartItems from state
  const [confirmationCartItems, setConfirmationCartItems] = useState([]);
  const [name, setAddressName] = useState("");
  useEffect(() => {
    setCartItems([]);
    const items = sessionStorage.getItem("cartItems");
    const name = sessionStorage.getItem("name");
    console.log(items, name);
    if (items) {
      setConfirmationCartItems(JSON.parse(items));
    }
    if (name) {
      setAddressName(name);
    }
    if (!items || items.length === 0) {
      navigate("/");
    }
    // Optionally clear these from sessionStorage if you don't need them anymore.
    // sessionStorage.removeItem('cartItems');
    // sessionStorage.removeItem('addressName');
  }, []);

  if (!confirmationCartItems || confirmationCartItems.length === 0) {
    return null; // Or a loader/spinner
  }
  return (
    <div className="container text-center">
      <div className="m-auto desktopWidth50 card rounded-0 border-0 checkoutCard mb-3 p-3 bg-white ">
        <h1 className="fw-bold text-primary-color">
          Thank you for your order, {name}.
        </h1>
        <br />
        <p className="confirmationTextLarge ">
          Delighted to let you know your order is confirmed.
        </p>
        {confirmationCartItems.map((item, index) => {
          const { selectedProduct, selectedSize, quantity } = item;
          const { prices, name, images } = selectedProduct;

          // Find the price object matching the selected size
          const priceObj = prices.find((price) => price.size === selectedSize);

          // Handle the case where the price is not found
          const price = priceObj ? priceObj.amount : 0;
          return (
            <li
              key={index}
              className="list-group-item confirmationCard d-flex flex-wrap justify-content-between align-items-center border-0 rounded-0 bg-white p-4"
            >
              <div className="d-flex align-items-center w-100">
                {/* Product Image */}
                <img
                  src={images[0]}
                  alt={name}
                  className="img-thumbnail me-3"
                  style={{
                    width: "80px",
                    objectFit: "cover",
                  }}
                />

                {/* Product Details */}
                <div className="w-100 text-start">
                  {/* Product Name and Price */}
                  <div className="d-flex flex-column flex-md-row justify-content-between mb-2">
                    <h5 className="mb-1">
                      <strong className="text-lowercase">{name}</strong>{" "}
                      <small className="text-capitalize">
                        - {selectedSize}
                      </small>
                    </h5>
                    <strong className="mb-1"> £{price.toFixed(2)}</strong>
                  </div>

                  {/* Quantity and Remove Button */}
                  <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
                    {/* Quantity Controls */}
                    <p className="mb-2 mb-md-0">
                      <small>
                        quantity:{" "}
                        <span className="quantity-value">{quantity}</span>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </li>
          );
        })}

        <p>
          Should you have any questions, do get in touch via the{" "}
          <Link to="/contact" className="orangeText">
            {" "}
            contact form
          </Link>{" "}
          on the website.
        </p>
        <br />
        <Link
          to="/events"
          className="p-2 rounded-0 desktopWidth50 m-auto fw-bold bg-primary-color text-white"
        >
          home of stories
        </Link>
      </div>
    </div>
  );
}

export default OrderConfirmationPage;
